/**
 * FinanceApp - Copyright (c) 2026 Emmanuel TESTE
 * Tous droits réservés - Logiciel propriétaire
 */
import { useState, useEffect } from 'react';

const STORAGE_KEY = 'financeapp_cookies_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  function accept() {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    setVisible(false);
  }

  function refuse() {
    localStorage.setItem(STORAGE_KEY, 'refused');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      background: '#0f172a', borderTop: '1px solid #1e293b',
      padding: '12px 24px', display: 'flex', alignItems: 'center',
      gap: 16, flexWrap: 'wrap', boxShadow: '0 -4px 20px rgba(0,0,0,0.4)',
    }}>
      <p style={{ margin: 0, fontSize: 13, color: '#94a3b8', flex: 1, minWidth: 200 }}>
        ExecPro360 utilise uniquement des cookies techniques nécessaires au fonctionnement
        (session, authentification). Aucun cookie publicitaire ou de tracking.{' '}
        <a
          href="/confidentialite" target="_blank" rel="noopener noreferrer"
          style={{ color: '#1a9e72', cursor: 'pointer', padding: 0, fontSize: 13, textDecoration: 'none' }}
        >
          En savoir plus
        </a>
      </p>
      <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
        <button onClick={refuse} style={{
          background: 'transparent', border: '1px solid #334155',
          color: '#94a3b8', padding: '6px 16px', borderRadius: 6,
          fontSize: 12, cursor: 'pointer',
        }}>
          Refuser
        </button>
        <button onClick={accept} style={{
          background: '#1a9e72', border: 'none', color: '#fff',
          padding: '6px 16px', borderRadius: 6, fontSize: 12, cursor: 'pointer',
        }}>
          Accepter
        </button>
      </div>
    </div>
  );
}
